module.exports = __webpack_public_path__ + "static/media/VTap.165d814b.jfif";